export default {
  baseStyle: {
    fontWeight: "bold",
    borderRadius: "xl",
  },
};
